module.exports = __webpack_public_path__ + "ebce4821a0d1d70d509082c27f93f24d.png";